<button mat-flat-button class="filter-table-button" (click)="openFilterDialog($event.target)"
        [ngClass]="{'filter-active':query}" [matTooltip]="query ? query_tooltip : no_query_tooltip">
  <mat-icon>filter_list</mat-icon>
  Filter
</button>
